import ImgList from "../modules/imagelist";
import Renoir from "../modules/renoir";
import Material from "../modules/material";
import Webflow from "../modules/webflow";
import Custom1 from "../modules/custom1";
import Homepage from "../modules/homepage";
import Homepage2 from "../modules/homepage-2";
import KimaHpOverlay from "../modules/kima-hp-overlay";
import KimaHPList from "../modules/kima-hp-list";
import KimaList from "../modules/kima-list";
import WmaHpOverlay from "../modules/wma-hp-overlay";
import WmaHPList from "../modules/wma-hp-list";
import WmaList from "../modules/wma-list";
import M5kHp from "../modules/m5k-hp";
import M5kList from "../modules/m5k-list";
import M5kList2 from "../modules/m5k-list2";
import Base from "../modules/base";
import LanguageSelectionPage from "../modules/language-selection";
import BaseThumbnailsPage from "../modules/base-thumbnails";

const getViewModule = (selectedModule) => {
    switch (selectedModule) {
        case 'base':
            return Base;
        case 'base-thumbnails':
            return BaseThumbnailsPage;
        case 'language-selection':
            return LanguageSelectionPage;
        case 'imagelist':
            return ImgList;
        case 'renoir':
            return Renoir;
        case 'material':
            return Material;
        case 'webflow':
            return Webflow;
        case 'custom1':
            return Custom1;
        case 'homepage':
            return Homepage;
        case 'homepage-2':
            return Homepage2;
        case 'kima-hp-overlay':
            return KimaHpOverlay;
        case 'kima-hp-list':
            return KimaHPList;
        case 'kima-list':
            return KimaList;
        case 'wma-hp-overlay':
            return WmaHpOverlay;
        case 'wma-hp-list':
            return WmaHPList;
        case 'wma-list':
            return WmaList;
        case 'm5k-hp':
            return M5kHp;
        case 'm5k-list':
            return M5kList;
        case 'm5k-list2':
            return M5kList2;
        default:
            return Base;
    }
};

export {getViewModule};
